import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Dropdown, DropdownMenu, DropdownToggle, Form } from "reactstrap";
import ErrorIcon from "@mui/icons-material/Error";
import { IconButton } from "@mui/material";
import PropTypes from "prop-types";

//import Components
import Tooltip from "Components/Common/Tooltip";
import LanguageDropdown from "../Components/Common/LanguageDropdown";
import NotificationDrawer from "Components/NotificationDrawer";
import ProfileDropdown from "../Components/Common/ProfileDropdown";
import LightDark from "../Components/Common/LightDark";
import { SUPER_ADMIN } from "common/constant";
import { adminActivityLogRoute } from "Routes/constants";

const Header = ({ onChangeLayoutMode, layoutModeType }) => {
  const { roles } = useSelector((state) => state.Login);
  const navigate = useNavigate();

  const [search, setSearch] = useState(false);
  const toogleSearch = () => {
    setSearch(!search);
  };

  return (
    <>
      <div className="d-flex align-items-center">
        <Dropdown
          isOpen={search}
          toggle={toogleSearch}
          className="d-md-none topbar-head-dropdown header-item"
        >
          <DropdownToggle
            type="button"
            tag="button"
            className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
          >
            <i className="bx bx-search fs-22"></i>
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
            <Form className="p-3">
              <div className="form-group m-0">
                <div className="input-group">
                  <input
                    className="form-control"
                    placeholder="Search ..."
                    aria-label="Recipient's username"
                  />
                  <button className="btn btn-primary" type="submit">
                    <i className="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </Form>
          </DropdownMenu>
        </Dropdown>
        {/* LanguageDropdown */}
        <LanguageDropdown />

        {roles.includes(SUPER_ADMIN) && (
          <Tooltip title="Event Logs">
            <IconButton onClick={() => navigate(adminActivityLogRoute)}>
              <ErrorIcon sx={{ color: "#fff" }} />
            </IconButton>
          </Tooltip>
        )}

        {/* Dark/Light Mode set */}
        <LightDark
          layoutMode={layoutModeType}
          onChangeLayoutMode={onChangeLayoutMode}
        />
        {/* NotificationDropdown */}
        <NotificationDrawer />
        {/* ProfileDropdown */}
        <ProfileDropdown />
      </div>
    </>
  );
};

Header.propTypes = {
  onChangeLayoutMode: PropTypes.func,
  layoutModeType: PropTypes.string,
};

export default Header;
